import { useRef } from 'react';
import type { WfProps } from '../webflow/element';
import { useInView } from './useInView';

/**
 * Marks itself with `data-ix-in-view` once scrolled into view, starting CSS animations keyed
 * on it (e.g. the looping testimonial carousel in interactions.css).
 */
export function InViewSection({ as: Tag = 'section', children, ...props }: WfProps) {
  const ref = useRef<HTMLElement>(null);
  const inView = useInView(ref);
  return (
    <Tag ref={ref} {...props} data-ix-in-view={inView ? '' : undefined}>
      {children}
    </Tag>
  );
}
